import React from "react";
 
const AddressProofValidation = (props: any) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html:
          props &&
          props?.templateList?.find(
            (item: any) => item.slug === "address_proof_validation"
          )?.content,
      }}
    />
  );
};

export default AddressProofValidation;